import VerifyOtp from "../modules/auth/verify-otp/VerifyOtp";

export const urlConstant = {
    dashboardConstant: '/dashboard',
    bashRoute: "/",
    VerifyOtp: "/verify-otp",

    manageCelebrityRoute: "/manage-celebrity",
    manageHomeCategoryRoute : "/manage-home-category",

    notification: "/notification",
    addNotification: "/notification/add",
    viewNotification: "/notification/view",
    

}